import TrackingUtils from "@tracking/utils/TrackingUtils";

export const dataTransportadorasReducer = (state, action) => {
  state.items = action.payload.responseTransportadoras?.items || [];
  state.itemsApelidos = action.payload.responseApelidos?.items || [];

  state.itemsDiretoriosKitColeta =
    TrackingUtils.createArrayObjectDynamicProp(
      action.payload.responseDiretoriosKitColeta,
      "nomeDiretorio"
    ) || [];

  state.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: action.payload.responseTransportadoras?.totalPaginas,
    totalItems: action.payload.responseTransportadoras?.totalRegistros,
  };

  state.requestGetParams = action.meta.arg;
};
